import React from 'react';

import {CanvasRef} from 'canvas-core/chat/bnchCanvasMarkdown';

export interface ChatContextValue {
  openFile: (chatSessionId: string, externalFileId: string, filename: string, mimeType: string) => void;
  openCanvas: (canvas: CanvasRef) => void;
}

export const ChatContext = React.createContext<ChatContextValue | null>(null);
